import AppRouter from 'routes/AppRouter';
import AppProvider from 'context/AppProvider';
import './App.scss';
import AlertProvider from 'context/AlertProvider';

function App() {
  return (
    <AppProvider>
      <AlertProvider>
        <AppRouter />
      </AlertProvider>
    </AppProvider>
  );
}

export default App;
